import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjayAvatar } from '../../DjayAvatar';
export function PerfectionistIllustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3555">
      <div className="relative w-full h-full bg-gradient-to-b from-amber-200 to-yellow-500 overflow-hidden" data-id="element-3556">
        {/* Background: Golden Glow */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3557">
          <circle cx="100" cy="100" r="80" fill="#FEF08A" opacity="0.5" filter="blur(10px)" data-id="element-3558" />

          {/* Rays */}
          <g className="origin-center" style={{
          transformOrigin: '100px 100px'
        }} data-id="element-3559">
            {[...Array(12)].map((_, i) => <path key={i} d="M100 100 L95 0 L105 0 Z" fill="#FFFFFF" opacity="0.2" transform={`rotate(${i * 30} 100 100)`} data-id="element-3560" />)}
          </g>
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[10%]" data-id="element-3561">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-3562">
            <DjayAvatar size="hero" emotion={isUnlocked ? 'proud' : 'thinking'} variant={variant} accessory="trophy" animate={animate && isUnlocked} className="w-full h-full" data-id="element-3563" />
          </div>
        </div>

        {/* Foreground: 5 Golden Stars Arch */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3564">
            {/* Star 1 */}
            <g transform="translate(30, 80) rotate(-30) scale(0.8)" data-id="element-3565">
              <path d="M15 0 L19 10 L30 10 L21 17 L24 28 L15 21 L6 28 L9 17 L0 10 L11 10 Z" fill="#FDE047" stroke="#CA8A04" strokeWidth="1" data-id="element-3566" />
            </g>
            {/* Star 2 */}
            <g transform="translate(55, 45) rotate(-15) scale(0.9)" data-id="element-3567">
              <path d="M15 0 L19 10 L30 10 L21 17 L24 28 L15 21 L6 28 L9 17 L0 10 L11 10 Z" fill="#FDE047" stroke="#CA8A04" strokeWidth="1" data-id="element-3568" />
            </g>
            {/* Star 3 (Center) */}
            <g transform="translate(85, 25) scale(1.1)" data-id="element-3569">
              <path d="M15 0 L19 10 L30 10 L21 17 L24 28 L15 21 L6 28 L9 17 L0 10 L11 10 Z" fill="#FDE047" stroke="#CA8A04" strokeWidth="1" data-id="element-3570" />
            </g>
            {/* Star 4 */}
            <g transform="translate(125, 45) rotate(15) scale(0.9)" data-id="element-3571">
              <path d="M15 0 L19 10 L30 10 L21 17 L24 28 L15 21 L6 28 L9 17 L0 10 L11 10 Z" fill="#FDE047" stroke="#CA8A04" strokeWidth="1" data-id="element-3572" />
            </g>
            {/* Star 5 */}
            <g transform="translate(150, 80) rotate(30) scale(0.8)" data-id="element-3573">
              <path d="M15 0 L19 10 L30 10 L21 17 L24 28 L15 21 L6 28 L9 17 L0 10 L11 10 Z" fill="#FDE047" stroke="#CA8A04" strokeWidth="1" data-id="element-3574" />
            </g>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}